// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ytM1v","closeSection":"styles_closeSection__CDUKt","header":"styles_header__eszHt","line":"styles_line__p53pj","footer":"styles_footer__0q9e1"};